import React from "react";
import "./ContentContainer.css";
import "./ContentContainerSmall.css";

const ContentContainer = (props) => {
  return <div className={props.containerStyle}>{props.children}</div>;
};

export default ContentContainer;
